export default "__VITE_ASSET__BXgPsBxj__"